
const menuLinkFaker = () => {
    let firstNavItem = document.querySelector('.header__nav__list > li');

    // Si el primer item del nav ya tiene megamenu no lo secuestramos: el
    // listener vive en el <li> y el del megamenu en el <summary>, asi que un
    // click disparaba los dos y el drawer lateral tapaba el panel.
    if (firstNavItem !== null && firstNavItem.querySelector('.header__dropdown--megamenu') !== null) {
        return;
    }

    if (typeof firstNavItem !== 'undefined' && firstNavItem !== null) {
        firstNavItem.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('.menu-drawer-icon').click();
        });
    }
}

/**
 * This function will enable grou-accordions in the faqs page
 */
const buildUpFAQAccordions = () => {
    let faqPage = document.querySelector('.template.template--page.template--help');
    if (typeof faqPage !== 'undefined' && faqPage !== null) {
        //We're on the faq page, try to build the accordions
        let accordionsTitles = document.querySelectorAll('.section-accordions__title.h5');
        let accordionGroups = [];
        for (let i = 0; i < accordionsTitles.length; i++) {
            accordionGroups.push(accordionsTitles[i].parentNode);
        }

        //Apply styles and listeners for each group
        accordionGroups.forEach((group) => {
            //Add a floating chevron to the title
            let chevronDown = document.createElement('i');
            chevronDown.classList.add('fas', 'fa-chevron-down', 'section-accordions__title__chevron');
            group.querySelector('.section-accordions__title.h5').appendChild(chevronDown);
            //Also a hidden chevron up
            let chevronUp = document.createElement('i');
            chevronUp.classList.add('fas', 'fa-chevron-up', 'section-accordions__title__chevron');
            group.querySelector('.section-accordions__title.h5').appendChild(chevronUp);

            //first, hide the section-accordions__body child of the group
            group.querySelector('.section-accordions__body').style.display = 'none';
            //Hide the chevron up
            chevronUp.style.display = 'none';

            //Then add a click listener to the section-accordions__title h5
            group.querySelector('.section-accordions__title.h5').style.cursor = 'pointer';
            group.querySelector('.section-accordions__title.h5').addEventListener('click', (e) => {
                e.preventDefault();
                let groupBody = group.querySelector('.section-accordions__body');
                if (groupBody.style.display === 'none') {
                    groupBody.style.display = 'block';
                    chevronDown.style.display = 'none';
                    chevronUp.style.display = 'block';
                } else {
                    groupBody.style.display = 'none';
                    chevronDown.style.display = 'block';
                    chevronUp.style.display = 'none';
                }
            });
        });
    }
};

const getPredictiveResultsMainCollection = () => {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.search-predictive-main-collection').forEach(async (container) => {
      if (container.innerHTML.trim().length >= 2 || container.dataset.processed === 'true') {
        return;
      }

      const productId = container.getAttribute('data-product-id');
      if (!productId) return;

      const response = await fetch('https://kave-home-serbia.myshopify.myshopify.com/api/2024-04/graphql.json', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '62d4311be3e9bd5db4bb6d11eca23421',
        },
        body: JSON.stringify({
          query: `
            query {
              product(id: "gid://shopify/Product/${productId}") {
                collections(first: 99) {
                  edges {
                    node {
                      title
                      handle
                      metafields: metafield(namespace: "custom", key: "is_main_collection") {
                        value
                      }
                    }
                  }
                }
              }
            }
          `
        })
      });

      const json = await response.json();
      const collections = json?.data?.product?.collections?.edges ?? [];

      for (const { node } of collections) {
        if (node.metafields?.value === 'true') {
          container.innerHTML = `<a href="/collections/${node.handle}" class="custom-main-collection">${node.title}</a>`;
          container.setAttribute('data-processed', 'true');
          break;
        }
      }
    });
  });

  // Observar cambios en todo el body (puedes restringirlo si sabes dónde aparecerán los contenedores)
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // También lanzar una primera pasada por si ya hay elementos cargados
  const evt = new Event('init');
  document.dispatchEvent(evt);
};

window.setTimeout(() => {
    menuLinkFaker();
    buildUpFAQAccordions();
    getPredictiveResultsMainCollection();
}, 1500);

// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// Megamenu: portado desde testkorea (PR #624). No toca menuLinkFaker ni el
// resto de la inicializacion existente de este fichero.
// ---------------------------------------------------------------------------

// Reinicia la animacion de entrada del contenido. Quitar y volver a poner la
// clase no basta: mientras el <details> esta cerrado el navegador se salta el
// recalculo de estilo de su contenido, asi que al reabrir no detecta cambio y la
// animacion solo saltaba la primera vez que se abria cada panel.
const restartMegamenuContentAnimation = (root) => {
    root.querySelectorAll(
        '.header__dropdown__item__link, .header__dropdown__item__items--l3 a'
    ).forEach((list) => {
        list.style.animation = 'none';
        // Leer offsetHeight fuerza el reflow que separa los dos estados
        void list.offsetHeight;
        list.style.animation = '';
    });
};

const megamenuCategorySwitch = () => {
    document.querySelectorAll('.header__dropdown--megamenu').forEach((panel) => {
        if (panel.dataset.categorySwitchBound === 'true') {
            return;
        }

        // Los niveles 1 y 2 son selectores y se comportan igual: uno abierto a
        // la vez y cambio al pasar el raton. La diferencia es el estado inicial:
        // solo el nivel 1 se abre por defecto, para que la tercera columna no
        // aparezca hasta pasar el raton por un item del segundo nivel.
        const selectors = [];

        panel.querySelectorAll('.header__dropdown__item__list').forEach((list) => {
            const items = list.querySelectorAll(':scope > .header__dropdown__item > details');

            if (items.length === 0) {
                return;
            }

            const isTopLevel = list.closest('.header__dropdown__item__items') === null;

            const closeAll = () => {
                items.forEach((details) => {
                    const summary = details.querySelector(':scope > summary');

                    details.open = false;

                    if (summary !== null) {
                        summary.setAttribute('aria-expanded', 'false');
                    }
                });
            };

            const select = (target) => {
                // Sin esta guarda cada mouseenter relanzaba la animacion aunque
                // el item ya estuviese abierto
                if (target === null || target === undefined || target.open) {
                    return;
                }

                items.forEach((details) => {
                    const isTarget = details === target;
                    const summary = details.querySelector(':scope > summary');

                    details.open = isTarget;

                    if (summary !== null) {
                        summary.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
                    }
                });

                restartMegamenuContentAnimation(target);

                if (isTopLevel) {
                    // Al cambiar de categoria la tercera columna se vacia: solo
                    // vuelve a salir cuando se pasa por un item del nivel 2
                    selectors.forEach((level) => {
                        if (!level.isTopLevel) {
                            level.closeAll();
                        }
                    });

                    // La tarjeta vuelve a la del nivel 1. Se avisa desde aqui y
                    // no desde el mouseover porque mouseover se dispara antes
                    // que el cambio de categoria.
                    panel.dispatchEvent(new CustomEvent('megamenu:reset'));
                }
            };

            selectors.push({
                items: items,
                select: select,
                closeAll: closeAll,
                isTopLevel: isTopLevel,
            });

            if (isTopLevel) {
                select(items[0]);
            } else {
                closeAll();
            }

            items.forEach((details) => {
                const summary = details.querySelector(':scope > summary');

                if (summary !== null) {
                    // Sin esto el click nativo cerraria el item ya abierto
                    summary.addEventListener('click', (e) => {
                        // Los items con hijos tambien enlazan a su coleccion,
                        // como en la referencia. Si el click ha caido sobre el
                        // enlace, dejamos que navegue.
                        if (e.target.closest('a[href]') !== null) {
                            return;
                        }

                        e.preventDefault();
                        select(details);
                    });
                }

                details.parentElement.addEventListener('mouseenter', () => select(details));
            });
        });

        if (selectors.length === 0) {
            return;
        }

        panel.dataset.categorySwitchBound = 'true';

        // Al reabrir el panel volvemos a la primera opcion de cada nivel
        const outer = panel.closest('details');

        if (outer !== null) {
            outer.addEventListener('toggle', () => {
                if (!outer.open) {
                    return;
                }

                selectors.forEach((level) => {
                    if (level.isTopLevel) {
                        level.select(level.items[0]);
                    } else {
                        level.closeAll();
                    }
                });
            });
        }
    });
};

// La tarjeta lateral se queda fijada en el ultimo item con datos por el que se
// ha pasado. Con :hover puro parpadeaba: al cruzar el hueco entre dos items no
// hay nada en hover durante un frame y se veia la de por defecto.
const megamenuCardFollow = () => {
    document.querySelectorAll('.header__dropdown--megamenu').forEach((panel) => {
        if (panel.dataset.cardFollowBound === 'true') {
            return;
        }

        panel.dataset.cardFollowBound = 'true';

        const clear = () => {
            panel.querySelectorAll('.header__dropdown__media--is-active').forEach((card) => {
                card.classList.remove('header__dropdown__media--is-active');
            });
        };

        const activate = (card) => {
            if (card === null || card.classList.contains('header__dropdown__media--is-active')) {
                return;
            }

            clear();
            card.classList.add('header__dropdown__media--is-active');
        };

        // Volver al estado por defecto: la tarjeta del nivel 1 abierto. Si esa
        // categoria no tiene, no se marca ninguna y queda la del bloque.
        const fallback = () => {
            const open = panel.querySelector(
                '.header__dropdown__column > .header__dropdown__item__list > .header__dropdown__item > details[open]'
            );
            const card = open === null
                ? null
                : open.querySelector(':scope > .header__dropdown__media--l1');

            if (card === null) {
                clear();
                return;
            }

            activate(card);
        };

        panel.addEventListener('megamenu:reset', fallback);

        // megamenuCategorySwitch ya ha abierto el primer nivel 1 para cuando
        // llegamos aqui, asi que esto deja la tarjeta correcta desde el inicio
        fallback();

        panel.addEventListener('mouseover', (e) => {
            // Solo cuenta pasar por encima de la fila en si (enlace o summary).
            // Mirar el <li> no valia: el hueco entre filas del nivel 3 sigue
            // estando dentro del <li> del nivel 2, asi que resolvia al padre y
            // se colaba su imagen al cambiar de subitem.
            const row = e.target.closest(
                '.header__dropdown__item__link, .header__dropdown__item__items--l3 a'
            );

            // Fuera de una fila (huecos, relleno de columna) no tocamos nada:
            // eso es lo que mantiene fija la ultima tarjeta
            if (row === null) {
                return;
            }

            const item = row.closest('li');

            if (item === null) {
                return;
            }

            // Los items de nivel 1 llevan su tarjeta dentro del <details>, no
            // como hijo directo, asi que aqui cuentan como "sin tarjeta" y
            // limpian: justo lo que debe pasar al volver a la primera columna.
            const card = item.querySelector(':scope > .header__dropdown__media');

            if (card === null) {
                // El item existe pero no tiene tarjeta (coleccion sin imagen, o
                // item de nivel 1): se cae a la del nivel 1 abierto
                fallback();
                return;
            }

            activate(card);
        });
    });
};

// Un <details> cerrado no renderiza su contenido, asi que el fundido no puede
// ser solo CSS: abrimos primero y anadimos .is-open un frame despues; al cerrar
// quitamos la clase y esperamos a que termine la transicion antes de cerrar.
const MEGAMENU_TRANSITION_MS = 500;

// Cual esta abierto ahora mismo, para poder pasar de uno a otro sin fundido
let activeMegamenu = null;

const megamenuTransition = () => {
    document.querySelectorAll('.header__dropdown--megamenu').forEach((panel) => {
        const details = panel.closest('details');

        if (details === null || details.dataset.transitionBound === 'true') {
            return;
        }

        const summary = details.querySelector(':scope > summary');

        if (summary === null) {
            return;
        }

        details.dataset.transitionBound = 'true';

        let closeTimer = null;

        // El overlay arranca en el borde inferior de la cabecera para no
        // oscurecerla; lo medimos al abrir porque depende de la barra de anuncios
        const setOverlayTop = () => {
            const header = document.querySelector('.section--header');

            if (header === null) {
                return;
            }

            const bottom = Math.round(header.getBoundingClientRect().bottom);
            document.documentElement.style.setProperty('--megamenu-overlay-top', `${bottom}px`);
        };

        // Cierre sin fundido, para cuando se pasa a otro megamenu
        const closeImmediate = () => {
            if (closeTimer !== null) {
                window.clearTimeout(closeTimer);
                closeTimer = null;
            }

            details.classList.add('is-switching');
            details.classList.remove('is-open');
            details.open = false;
            summary.setAttribute('aria-expanded', 'false');

            if (activeMegamenu === details) {
                activeMegamenu = null;
            }

            requestAnimationFrame(() => details.classList.remove('is-switching'));
        };

        details.megamenuCloseImmediate = closeImmediate;

        const open = () => {
            if (closeTimer !== null) {
                window.clearTimeout(closeTimer);
                closeTimer = null;
            }

            // Si ya habia otro abierto, el panel debe sentirse el mismo con
            // otro contenido: cerramos y abrimos sin transicion
            const previous = activeMegamenu;
            const isSwitch = previous !== null
                && previous !== details
                && typeof previous.megamenuCloseImmediate === 'function'
                && (previous.open || previous.classList.contains('is-open'));

            if (isSwitch) {
                previous.megamenuCloseImmediate();
            }

            setOverlayTop();
            details.open = true;
            summary.setAttribute('aria-expanded', 'true');
            activeMegamenu = details;

            if (isSwitch) {
                // Con la transicion suprimida no hace falta esperar frames
                details.classList.add('is-switching', 'is-open');
                restartMegamenuContentAnimation(details);
                requestAnimationFrame(() => details.classList.remove('is-switching'));
                return;
            }

            // Dos frames: el panel pasa de no renderizado a renderizado, y sin
            // esta espera el navegador no tiene estado inicial que interpolar
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    details.classList.add('is-open');
                    restartMegamenuContentAnimation(details);
                });
            });
        };

        const close = () => {
            if (!details.open && !details.classList.contains('is-open')) {
                return;
            }

            details.classList.remove('is-open');
            summary.setAttribute('aria-expanded', 'false');

            if (activeMegamenu === details) {
                activeMegamenu = null;
            }

            closeTimer = window.setTimeout(() => {
                details.open = false;
                closeTimer = null;
            }, MEGAMENU_TRANSITION_MS);
        };

        // details-disclosure.js cierra por focusout quitando el atributo open
        // de golpe, sin animacion. Al hacer click dentro de la cabecera el foco
        // se mueve y saltaba ese camino. Sustituimos close() solo en esta
        // instancia para que pase por el cierre animado; el resto de
        // disclosures del tema (buscador, idioma) siguen igual.
        const disclosure = details.closest('details-disclosure');

        if (disclosure !== null) {
            disclosure.close = () => {
                // focusout salta en el mousedown, ANTES del click. Si el foco va
                // a otro megamenu no cerramos aqui: dejamos que el click del
                // otro summary haga el cambio sin fundido. Si no, este camino
                // se adelantaba, arrancaba el fundido y borraba activeMegamenu,
                // asi que open() ya no detectaba el cambio.
                const focused = document.activeElement;
                const otherDetails = focused === null ? null : focused.closest('details');
                const movingToAnotherMegamenu = otherDetails !== null
                    && otherDetails !== details
                    && typeof otherDetails.megamenuCloseImmediate === 'function';

                if (movingToAnotherMegamenu) {
                    return;
                }

                close();
            };
        }

        summary.addEventListener('click', (e) => {
            e.preventDefault();

            // Comprobamos tambien details.open: details-disclosure.js puede
            // haber quitado el atributo por focusout dejando la clase puesta
            if (details.open && details.classList.contains('is-open')) {
                close();
            } else {
                open();
            }
        });

        document.addEventListener('click', (e) => {
            if (details.classList.contains('is-open') && !details.contains(e.target)) {
                close();
            }
        });

        // Como en kavehome.com: al empezar a hacer scroll el menu se cierra
        window.addEventListener('scroll', () => {
            if (details.classList.contains('is-open')) {
                close();
            }
        }, { passive: true });
    });
};


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        megamenuCategorySwitch();
        megamenuTransition();
        megamenuCardFollow();
    });
} else {
    megamenuCategorySwitch();
    megamenuTransition();
    megamenuCardFollow();
}

document.addEventListener('shopify:section:load', () => {
    megamenuCategorySwitch();
    megamenuTransition();
    megamenuCardFollow();
});
